import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";

export default function ExternalLink({href, children}) {
   return (
       <a href={href} target="_blank" without rel="noopener noreferrer">{children}<FontAwesomeIcon icon={faExternalLinkAlt} /></a>
   )
}
